import styled from "styled-components";

export const DetailsPermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-inline: 50px;
  position: relative;
  min-height: 100vh;
  padding-bottom: 100px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
`;

export const LeftColumn = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  & > div {
    width: 100%;
  }
`;

export const RightColumn = styled.div`
  width: 60%;
  display: flex;
  
  & > div {
    width: 100%;
  }
`;

export const RightColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 12px;
  width: 100%;
`;

export const BreadcrumbContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const TwoColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
`;

export const FirstColumn = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
`;

export const SecondColumn = styled.div`
  width: 40%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const SwitchLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SwitchTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

